import Swal from "sweetalert2";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {log} from "@/state/pinia/log";
import {useLazyLoaderModule, usePackagesManagerModule} from "@/state/pinia";

export const packagesHelperMethods = {
    exportGroupOrderToFile(groupOrder, outputFileFormat, sendEmailToDrugstores, askForEmail,flatExport) {
        const lazyLoaderModule = useLazyLoaderModule()
        const packagesModule = usePackagesManagerModule()
        lazyLoaderModule.setDisplayLazyLoader(true);
        lazyLoaderModule.setProgressBarMessage( "Eksportowanie listy płatności do pliku");


        const payload = {
            orderGroupGuid: groupOrder.groupGuid,
            outputFileFormat: outputFileFormat,
            flatExport:flatExport
        }

        return packagesModule.httpExportGroupOrderToFile(payload).then((response) => {
            lazyLoaderModule.setDisplayLazyLoader(false);
            if (response.status !== 200) {
                log.log(response)
                var responseMessage = response.data
                apiRequestsHelper.fireExceptionModal("Coś jest nie tak!", responseMessage, "warning")
                    .then(() => {
                            lazyLoaderModule.setDisplayLazyLoader(false);
                            lazyLoaderModule.setProgressBarMessage( "");
                        }
                    );

                return new Promise((resolve) => {
                    resolve({isConfirmed: false});
                });

            }

            if (sendEmailToDrugstores) {
                return packagesHelperMethods.sendEmailToDrugstores(groupOrder, response, outputFileFormat, "PKT_", askForEmail);
            } else {
                return packagesHelperMethods.parseFileResource(response, outputFileFormat, "PKT_");
            }


        }).catch((error) => {
            return apiRequestsHelper.catchResponseError(error, "httpExportGroupOrderToFile");
        });
    },

    sendEmailToDrugstores(groupOrder, fileResponse, fileOutputFormat, fileNamePrefix, askForEmail) {
        // inform user that export is successful and ask if he would like to send an e-mail with the file
        if (askForEmail) {
            return Swal.fire({
                title: "Eksport zakończony",
                text: "Eksport danych zakończony sukcesem. Czy chcesz wysłać plik na e-mail?",
                icon: "success",
                showCloseButton: true,
                showConfirmButton: true,
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText: 'Tak',
                cancelButtonText: 'Nie',
                width: 900,
                customClass: {
                    container: "swal-highest"
                },
            }).then((proceed) => {

                if (proceed.isConfirmed) {

                    return packagesHelperMethods.prepareGroupOrderMailForm(groupOrder, fileResponse);
                } else {
                    return packagesHelperMethods.parseFileResource(fileResponse, fileOutputFormat, fileNamePrefix).then(() => {
                        return new Promise((resolve) => {
                            resolve({isConfirmed: false});
                        });
                    });

                }


            });
        } else {
            return packagesHelperMethods.prepareGroupOrderMailForm(groupOrder, fileResponse);
        }

    },

    prepareGroupOrderMailForm(groupOrder, fileResponse) {
        const lazyLoaderModule = useLazyLoaderModule()
        const packagesModule = usePackagesManagerModule()
        lazyLoaderModule.setDisplayLazyLoader(true);
        lazyLoaderModule.setProgressBarMessage( "Przygotowuję treść wiadomości...");
        const orderDataPayload = {
            orderGroupGuid: groupOrder.groupGuid
        }
        return packagesModule.httpGetDrugstoresForGroupOrder(orderDataPayload).then((response) => {
            lazyLoaderModule.setDisplayLazyLoader(false);
            const drugstoresData =  response.data.payload;
            console.log("groupOrder:");
            console.log(groupOrder);

            const sendMailDialogTitle = "Wyślij plik zamówienia PKT: " + groupOrder["orderName"];
            const mailSubject = "PKT " + groupOrder["orderName"];
            const mailMessage = "Dzień dobry, \n W załączniku znajduje plik z zamówieniem PKT: " + groupOrder["orderName"] + ". Zamówienie będzie realizowane przez " +
                groupOrder["supplierName"] + "  \n\n" +
                "\n\n Pozdrawiam, \n";

            const mailTo = drugstoresData != null ? drugstoresData
                .filter(d=> d.email != null && d.email !== "")
                .map(d=> d.email).join(",") : "";
            const mailAttachmentName = packagesHelperMethods.getResourceFileNameFromHeader(fileResponse);

            return new Promise((resolve) => {
                resolve(
                    {
                        isConfirmed: true,
                        sendMailDialogTitle: sendMailDialogTitle,
                        mailMessage: mailMessage,
                        mailSubject: mailSubject,
                        mailTo: mailTo,
                        mailCc: "",
                        mailAttachmentName: mailAttachmentName,
                    }
                );
            });

        })


    },
    getFileNameToSave(fileType, fileNamePrefix) {
        // get current system millis
        const millis = new Date().getTime();
        //setting default file name
        return fileNamePrefix + "_export" + new Date().toLocaleDateString() + "_" + millis + "." + fileType;
    },

    getResourceFileNameFromHeader(response) {
        // Get the Content-Disposition header
        const contentDisposition = response.headers['content-disposition'];
        let filename = null;
        if (contentDisposition) {
            // 1. Trial to parse filename*=UTF-8'' (the most common situation)
            let matches = /filename\*=UTF-8''([^;]*)/.exec(contentDisposition);
            if (matches && matches[1]) {
                filename = decodeURIComponent(matches[1]);
            }
            // 2. The trial to parse (RFC 2047: =?UTF-8?Q?...)
            else {
                matches = /filename="?=\?UTF-8\?Q\?([^?]*)\?="?/i.exec(contentDisposition);
                if (matches && matches[1]) {
                    // In this format the characters are prefixed with =, np =C5.
                    // JS decodeURIComponent need %, np %C5.
                    // Additional spaces in Q-encoding are often like _, and we have to replace the with actual spaces
                    let messyString = matches[1].replace(/=/g, '%').replace(/_/g, ' ');
                    try {
                        filename = decodeURIComponent(messyString);
                    } catch (e) {
                        console.error("Błąd dekodowania nazwy pliku", e);
                        filename = matches[1]; // Fallbackfor encoded version
                    }
                }
                // 3. Ordinary fallback
                else {
                    matches = /filename="?([^"]*)"?/.exec(contentDisposition);
                    if (matches && matches[1]) {
                        filename = matches[1];
                    }
                }
            }
        }

        return filename;
    },

    parseFileResource(response, defaultFileType, defaultFileNamePrefix) {

        //determine the content type from the header or default to octect stream

        // Extract filename from header
        let filename = packagesHelperMethods.getResourceFileNameFromHeader(response);
        if (filename === null) {
            filename = packagesHelperMethods.getFileNameToSave(defaultFileType, defaultFileNamePrefix);
        }

        var octetStreamMime = 'application/octet-stream';
        var contentType = response.headers["content-type"] || octetStreamMime;
        var blob = new Blob([response.data], {type: contentType});
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        return new Promise((resolve) => {
            resolve({isConfirmed: true});
        });

    },

    openShareForm(order) {

        if (order.central) {
            return Swal.fire("To zamówienie zostało już wysłane", "", "success");
        } else {
            const packagesModule = usePackagesManagerModule()
            return Swal.fire({
                title: "Czy na pewno wysłać zamówienie do realizacji?",
                text: "Zamówienie będzie widoczne dla aptek, uniemożliwi to także edycje zamówienia.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                cancelButtonText: "Anuluj",
                confirmButtonText: "Udostępnij"
            }).then((result) => {
                if (result.isConfirmed) {
                    // means in group view and we clicked share on whole group
                    const payload = {
                        orderGroupGuid: order.groupGuid
                    }
                    return packagesModule.httpSharePackageOrderByGuid(payload)
                        .then((response) => {
                            if(response && response.status === 200){
                                return new Promise((resolve) => {
                                    resolve(
                                        {
                                            isConfirmed: true
                                        }
                                    );
                                });

                            }

                        }).then(()=>{
                            this.lazyLoaderModule.setDisplayLazyLoader(false);
                        })

                }
            });
        }

    },

    saveGroupOrderFormData(dataToSave,currentGroupOrder) {
        console.log("saveGroupOrderFormData...",dataToSave);
        console.log("current order...",dataToSave);
        const packagesModule = usePackagesManagerModule()
        const basicOrderData = JSON.parse(JSON.stringify(currentGroupOrder)); // MAKING A COPY TO FULFILL EDITED FIELDS
        basicOrderData.orderName = dataToSave.orderName
        basicOrderData.orderCreationDate = dataToSave.orderCreationDate
        basicOrderData.centralSupplierGuid = dataToSave.centralSupplierGuid
        basicOrderData.wholesalerGuid = dataToSave.wholesalerGuid
        basicOrderData.dividerMainDrugstoreClientId = dataToSave.dividerMainDrugstoreClientId
        basicOrderData.notifications = dataToSave.notifications
        basicOrderData.toDivide = dataToSave.toDivide


        basicOrderData.doCreateProspect = dataToSave.doCreateProspect
        basicOrderData.prospectExpiryDate = dataToSave.prospectExpiryDate
        basicOrderData.prospectCloseDate = dataToSave.prospectCloseDate
        basicOrderData.prospectAllowModifyAmount = dataToSave.prospectAllowModifyAmount
        basicOrderData.prospectAllowAddProducts = dataToSave.prospectAllowAddProducts
        basicOrderData.prospectAllowPurchasePrice = dataToSave.prospectAllowPurchasePrice
        return packagesModule.httpUpdateGroupOrderBasicData(basicOrderData)
        .then((response) => {
            return new Promise((resolve) => {
                resolve(response)
            })
        })
    },

    displayAmountSetterWarningDialog(option){
        return  Swal.fire({
            title: "Ustawienie wartości",
            html:
                `<div style="text-align:left">`+
                `<p>Czy na pewno chcesz ustawić wartość "${option.label}" dla wszystkich produktów w zamówieniu i wszytskich aptek?<br/>Proces może zająć chwilę.</p>`+
                `<div role="group" aria-labelledby="calc-mode-label">
            <label id="calc-mode-label" style="font-weight:600; display:block; margin:8px 0;">Wybierz sposób wyliczania:</label>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="calcMode" id="calcModeOriginal" value="ORIGINAL_STATE">
              <label class="form-check-label" for="calcModeOriginal">${option.label}</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="calcMode" id="calcModeMinusPackage" value="STATE_MINUS_PACKAGE_STOCK" checked>
              <label class="form-check-label" for="calcModeMinusPackage">${option.label} minus stan magazynowy towaru oznaczonego jako pakiet</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="calcMode" id="calcModeMinusAll" value="STATE_MINUS_ALL_STOCK">
              <label class="form-check-label" for="calcModeMinusAll">${option.label} minus całkowity stan magazynowy towaru w aptece</label>
            </div>
          </div></div>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Tak, ustaw",
            cancelButtonText: "Anuluj",
            focusConfirm: false,
            preConfirm: () => {
                const selected = document.querySelector('input[name="calcMode"]:checked');
                if (!selected) {
                    Swal.showValidationMessage('Wybierz jedną z opcji');
                    return false;
                }
                return selected.value;
            },
            customClass: {
                container: "swal-highest"
            }
        })
    },

    formatDateToLocale(date) {
        if (date === null || date === undefined) {
            return null;
        }

        var dateObj = new Date(date);
        return dateObj.toLocaleDateString();
    },
    formatDatetimeToLocaleFormat(datetime) {
        if (datetime === null || datetime === undefined) {
            return null;
        }

        var dateObj = new Date(datetime);
        // format datetime to pattern dd.MM.yyyy HH:mm:ss
        return dateObj.toLocaleDateString() + " " + dateObj.toLocaleTimeString();

    },
    formatDateToISO(date) {
        if (date === null || date === undefined) {
            return null;
        }

        var dateObj = new Date(date);
        return dateObj.toISOString().split('T')[0];
    },


    formatTime(daySeconds) {
        // check if daySeconds match an array with hours, mins and seconds
        if (Array.isArray(daySeconds)) {
            var hoursVal = daySeconds[0];
            var minutesVal = daySeconds[1];
            var secondsVal = daySeconds[2];
            return hoursVal + ":" + minutesVal + ":" + secondsVal;
        }

        var hours = Math.floor(daySeconds / 3600);
        var minutes = Math.floor((daySeconds - (hours * 3600)) / 60);
        var seconds = daySeconds - (hours * 3600) - (minutes * 60);

        return hours + ":" + minutes + ":" + seconds;
    },
};
